var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"image",class:{rounded: _vm.rounded, 'bg': _vm.showBg},attrs:{"data-id":_vm.imageRef,"src":_vm.imgSrc,"alt":_vm.alt,"title":_vm.alt,"id":("js-img-" + _vm._uid)},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }